import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AlertRulesView from '@/views/AlertRulesView.vue'
import AdminSettingsView from '@/views/AdminSettingsView.vue'
import AppearanceView from '@/views/AppearanceView.vue'
import { recoverNavigation } from '@/utils/navigation-recovery'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/auth/logout',
      name: 'logout',
      component: () => import('@/views/LogoutView.vue'),
      meta: { public: true },
    },
    {
      path: '/auth/logout/complete',
      name: 'logout-complete',
      component: () => import('@/views/LogoutCompleteView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
    },
    {
      path: '/uptime',
      name: 'uptime',
      component: () => import('@/views/UptimeView.vue'),
    },
    {
      path: '/nodes/:id',
      name: 'node',
      component: () => import('@/views/NodeView.vue'),
      props: true,
    },
    {
      path: '/settings/appearance',
      name: 'appearance',
      component: AppearanceView,
    },
    {
      path: '/settings/alerts',
      name: 'alerts',
      component: AlertRulesView,
    },
    {
      path: '/settings/admin',
      name: 'admin',
      component: AdminSettingsView,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue'),
      meta: { public: true },
    },
  ],
})

router.onError((error, to) => {
  if (!recoverNavigation(error, to.fullPath))
    window.dispatchEvent(new Event('pulsewatch:navigation-error'))
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.initialize()
  if (!to.meta.public && !auth.authenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && auth.authenticated) return { name: 'dashboard' }
  return true
})

export default router
